import React from 'react';
import DraggableModal from 'components/DraggableModal';

import {DialogTypes} from 'common/names';
import SearchPartnerForm from './SearchPartnerForm';
import {openDialogOutside} from 'common/openDialogOutside';

type SearchPartnerDialogProps = {
   header: string;
   onClose: () => void;
};

const SearchPartnerDialog = ({header, onClose}: SearchPartnerDialogProps) => {
   const openOutside = React.useCallback(
      () => openDialogOutside(DialogTypes.SearchPartnerDialog.id),
      []
   );

   return (
      <DraggableModal width={'md'} header={header} onClose={onClose} onLaunch={openOutside}>
         <SearchPartnerForm onClose={onClose} />
      </DraggableModal>
   );
};

export default React.memo(SearchPartnerDialog);
